import type { Lottery } from '@lotta/shared/types-lottery-schemas';
import type { Expand } from '@lotta/shared/util-utilities';
import { isDeleteLotteryAllowed } from './is-delete-lottery-allowed';
import { isEditLotteryAllowed } from './is-edit-lottery-allowed';

export type LotteryEditPhase = 'OPEN' | 'LIMITED' | 'CLOSED' | 'COPY';

type RequiredLotteryProps = Expand<
  Pick<Lottery, 'lotteryStatus' | 'occurrence' | 'drawDay' | 'drawTime'>
>;

export const getLotteryEditPhase = (
  lottery: RequiredLotteryProps,
  timezone: string,
  date: Date
): LotteryEditPhase => {
  if (!isEditLotteryAllowed(lottery, timezone, date)) {
    return 'CLOSED';
  }
  if (!isDeleteLotteryAllowed(lottery, timezone, date)) {
    return 'LIMITED';
  }
  return 'OPEN';
};
